import { gql } from '@apollo/client';
import STUDY_INFO_CLINIC_FRAGMENT from '../fragments/studyInfoClinicFragment';

const STUDY_INFO_CLINIC_WEB_VIEW_QUERY = gql`
  query studyInfoClinicWebView($id: ID!) {
    study(id: $id) {
      ...StudyInfoClinicFragment
      lastStudyHistory {
        time
        status
      }
    }
  }

  ${STUDY_INFO_CLINIC_FRAGMENT}
`;

export default STUDY_INFO_CLINIC_WEB_VIEW_QUERY;
